<script>
export default {
    name: 'UiAutoLinkText',
	props: ['text'],
	render: function (createElement) {
		var a = this.text.split(/(https?:\/\/.*([1-9]*:)?[\w!?\/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+)/i)
		a = a.filter((p) =>  p !== undefined)
		var vnodes = a.map(function(x, i) {
			if (i % 2) {
				return createElement('a', {attrs:{href:x, target:'_blank', rel:'noopener noreferrer'}}, x)
			} else {
				return createElement('span', {}, x)
			}
		}, this);
		return createElement(
			'div',
			{ class: 'pre-wrap-text' },
			vnodes
		)
	}
}
</script>

<style scoped>
.pre-wrap-text {
	white-space: pre-wrap;
}
</style>